import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Kombiniert Klassennamen (clsx) und mergt Tailwind-Konflikte (tailwind-merge). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
